import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class WebApiService {
    public static serverUrl = 'https://man.getsoft.co.za/';
    // public static serverUrl = 'http://localhost:64197/';

    constructor( private http: Http, private router: Router )
    {
        let base = window.location.origin;
        if (base.indexOf( 'localhost' ) > -1) {
            WebApiService.serverUrl = 'http://localhost:64197/';
        }
    }

    post(url: string, body: any): Promise<any> {
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.post(WebApiService.serverUrl + url, body,
            {
                headers: headers
            })
            .toPromise()
            .then((response: Response) => {
                if (response.arrayBuffer.length > 0 || response.toString().length > 0)
                {
                    return response.json();
                }
                return null;
            })
            .catch((error) => {
                if (error.status === 401) {
                    this.router.navigate(['login']);
                }

                return this.handleError(error);
            });
    }

    put(url: string, body: any) {
        let headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.put(WebApiService.serverUrl + url, body, {
                headers: headers
            })
            .toPromise()
            .then(response => {
                if (response.arrayBuffer.length > 0 || response.toString().length > 0)
                {
                    return response.json();
                }
                return null;
            })
            .catch((error) => {
                if (error.status === 401) {
                    this.router.navigate(['login']);
                }

                return this.handleError(error);
            });
    }


    get(url: string): Promise<any> {
        let headers = new Headers();
        this.createAuthorizationHeader( headers );
        return this.http.get(WebApiService.serverUrl + url,
            {
                headers: headers
            })
            .toPromise()
            .then(response => {
                let dbg = response.json();
                return dbg;
            })
            .catch((error) => {
                if (error.status === 401) {
                    this.router.navigate(['login']);
                }

                return this.handleError(error);
            });
    }

    createAuthorizationHeader(headers: Headers) {
        headers.append('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem('token')));
    }

    private handleError(error: Response): Promise<any> {
        let a = error.json();
        return Promise.reject(a || error.text || error.toString() || error.statusText || error.status || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/webapi.service.ts